import React from 'react';
import { Form } from 'react-final-form';

import { Heading } from '../../components/atoms/Heading';
import { ProgressBar } from '../../components/molecules/ProgressBar';
// import { Image } from '../../components/atoms/Image';
import { MainView } from '../../templates/MainView';

import { StickyButtons } from '../../components/molecules/StickyButtons';
import { ButtonGroup } from '../../components/molecules/ButtonGroup';
import { Button } from '../../components/atoms/Button';
import { useNavigate } from 'react-router-dom';

import PathwayForm from '../../components/forms/PathwayForm';

function Pathway() {
    const navigate = useNavigate();

    return (
        <MainView>
            <Form
                onSubmit={(values) => navigate(`/pathway-${values.pathway}`)}
                initialValues={{
                    pathway: '',
                }}>
                {({ handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="h-auto w-full">
                            <div className="flex flex-col md:flex-col-reverse">
                                <ProgressBar min={0} current={1} max={3} />
                                <div className="bg-primary-200 p-5 md:bg-transparent">
                                    <Heading h3 classes="text-lg md:text-xl">
                                        Habit Hacker
                                    </Heading>
                                </div>
                            </div>
                            <PathwayForm />
                            <div className="px-6 pb-12 pt-6">
                                <StickyButtons>
                                    <ButtonGroup
                                        mode="pair"
                                        alwaysRow
                                        buttons={[
                                            <Button
                                                label="Back"
                                                mode="secondary"
                                                onClick={() => navigate(-1)}
                                                type="button"
                                                // isDisabled={isFirstStep}
                                            />,
                                            <Button
                                                label="Continue"
                                                mode="primary"
                                                isSubmit
                                                isDisabled={!values.pathway}
                                            />,
                                        ]}
                                    />
                                </StickyButtons>
                            </div>
                        </div>
                    </form>
                )}
            </Form>
        </MainView>
    );
}

export default Pathway;
